import type { IconSvgObject } from './types';

const Grid2X2CheckIcon: IconSvgObject = [
  ["path", { d: "M11.5 21H4.5C3.39543 21 2.5 20.1046 2.5 19V5C2.5 3.89543 3.39543 3 4.5 3H18.5C19.6046 3 20.5 3.89543 20.5 5V12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M15.5 19L17.5 21L21.5 17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M11.5 3V21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M20.5009 11.9922H2.50586", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default Grid2X2CheckIcon;
